export function Card({ children, className = '', onClick }) {
  return (
    <div
      className={`glass-card p-4 ${onClick ? 'cursor-pointer hover:bg-white/10 transition-colors' : ''} ${className}`}
      onClick={onClick}
    >
      {children}
    </div>
  );
}
